import React from 'react'
import { useIntl } from 'react-intl'

import { Flex, Text, Title, TITLE_VARIANT_MODAL } from 'mailup-web-components'

const Descriptions = () => {
  const intl = useIntl()
  return (
    <Flex flexDirection='column' margin='8px 0 24px 0' rowGap='32px'>
      <Title variant={TITLE_VARIANT_MODAL}>
        {intl.formatMessage({ id: 'Load.LinkUrlSelection.Title' })}
      </Title>
      <Text>
        {intl.formatMessage({ id: 'Load.LinkUrlSelection.Description' })}
      </Text>
    </Flex>
  )
}

export default Descriptions
